import React, { useState, useEffect } from "react";
import { Modal, Button, ProgressBar } from "react-bootstrap";
import { SECURITY_CONFIG } from "../config/security";

/**
 * Session Timeout Warning Modal
 * Shows a warning before the session expires with countdown timer
 */
const SessionTimeoutModal = ({ show, remainingTime, onExtend, onLogout }) => {
  const [timeLeft, setTimeLeft] = useState(remainingTime);

  useEffect(() => {
    if (show) {
      setTimeLeft(remainingTime);

      const interval = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1000) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1000;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [show, remainingTime]);

  const formatTime = (ms) => {
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, "0")}`;
  };

  const progressPercentage =
    (timeLeft / SECURITY_CONFIG.SESSION.WARNING_TIME) * 100;

  return (
    <Modal
      show={show}
      onHide={() => {}}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header>
        <Modal.Title>Session Expiring Soon</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center mb-3">
          <p className="mb-3">
            Your session will expire in{" "}
            <strong className="text-danger">{formatTime(timeLeft)}</strong>
          </p>
          <p className="text-muted">
            For your security, you will be automatically logged out due to
            inactivity.
          </p>
        </div>
        <ProgressBar
          variant="danger"
          now={progressPercentage}
          animated
          className="mb-3"
        />
        <div className="text-center text-muted small">
          <p className="mb-0">Do you want to stay logged in?</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onLogout}>
          Logout Now
        </Button>
        <Button variant="primary" onClick={onExtend}>
          Stay Logged In
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionTimeoutModal;
